<template>
    <div class="section-confirm">
        <div class="container text-center">
            <div class="logo-container">
                <img class="n-logo" width="130" height="40" src="img/logotipo_mod2.png" alt="U4CROWD" />
            </div>
            <div class="row justify-content-md-center">
                <div class="col-md-12 col-lg-8">
                    <h3 class="title">¡Te has registrado al proyecto con éxito, recibirás instrucciones por correo electrónico!</h3>
                    <span v-if="loading"><square-grid background="#FFFFFF"></square-grid> Loading...</span>
                    <alert v-if="success" type="success">
                        {{success.message}}
                    </alert>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {RotateSquare2, SquareGrid} from 'vue-loading-spinner'
import { Alert } from '@/components';
import Investments from '@/providers/Investments'
const provider = new Investments()

export default {
  name: 'investment-register',
  components: {
    RotateSquare2,
    SquareGrid,
    Alert
  },
  mounted() {
      this.validToken(this.$route.query._tk);
  },
  data() {
    return {
        loading: false,
        success: null
    }
  },
  methods: {
      validToken(token) {
        this.loading = true
        let data = {
            _tk: token
        }
        provider.confirm(data).then((resp)=> {
            setTimeout(() => {
                this.error = null
                this.loading = false
                this.$router.push('/panel') 
            }, 3000);
        }).catch((err)=>{
            this.$router.push('/panel') 
      })
      }
  }
};
</script>
<style>
</style>
